// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EarnBlock-centerBlock-ALWW2 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	text-align: center;
	max-width: var(--max-content-width);
	width: 100%;
}

.EarnBlock-mainBlock-kQmGG {
	padding: 90px 0 42px;
}

.EarnBlock-tryButton-vAAAy {
	height: 50px;
	line-height: 49px;
	font-size: 18px;
	padding: 0 18px;
	margin-top: 30px;
	color: var(--white-text) !important;
	border-color: var(--btn-primary-bg) !important;
	background-color: var(--btn-primary-bg) !important;
	outline: none !important;
}

.EarnBlock-heading-BR_1X {
	font-size: 48px;
	margin-bottom: 12px !important;
	margin-top: 0px !important;
	font-weight: 600;
}

.EarnBlock-estimate-pWB6R {
	font-size: 18px;
	margin-top: 0;
	line-height: 26px;
}

@media (max-width: 450px) {
	.EarnBlock-heading-BR_1X {
		font-size: 25px;
	}

	.EarnBlock-estimate-pWB6R,
	.EarnBlock-desc-HnGzW {
		font-size: 18px;
	}

	.EarnBlock-mainBlock-kQmGG {
		padding: 30px 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/EarnBlock/EarnBlock.css"],"names":[],"mappings":"AAAA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;CAClB,mCAAmC;CACnC,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,mCAAmC;CACnC,8CAA8C;CAC9C,kDAAkD;CAClD,wBAAwB;AACzB;;AAEA;CACC,eAAe;CACf,8BAA8B;CAC9B,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;;EAEC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":[".centerBlock {\n\tdisplay: flex;\n\tjustify-content: center;\n\ttext-align: center;\n\tmax-width: var(--max-content-width);\n\twidth: 100%;\n}\n\n.mainBlock {\n\tpadding: 90px 0 42px;\n}\n\n.tryButton {\n\theight: 50px;\n\tline-height: 49px;\n\tfont-size: 18px;\n\tpadding: 0 18px;\n\tmargin-top: 30px;\n\tcolor: var(--white-text) !important;\n\tborder-color: var(--btn-primary-bg) !important;\n\tbackground-color: var(--btn-primary-bg) !important;\n\toutline: none !important;\n}\n\n.heading {\n\tfont-size: 48px;\n\tmargin-bottom: 12px !important;\n\tmargin-top: 0px !important;\n\tfont-weight: 600;\n}\n\n.estimate {\n\tfont-size: 18px;\n\tmargin-top: 0;\n\tline-height: 26px;\n}\n\n@media (max-width: 450px) {\n\t.heading {\n\t\tfont-size: 25px;\n\t}\n\n\t.estimate,\n\t.desc {\n\t\tfont-size: 18px;\n\t}\n\n\t.mainBlock {\n\t\tpadding: 30px 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centerBlock": `EarnBlock-centerBlock-ALWW2`,
	"mainBlock": `EarnBlock-mainBlock-kQmGG`,
	"tryButton": `EarnBlock-tryButton-vAAAy`,
	"heading": `EarnBlock-heading-BR_1X`,
	"estimate": `EarnBlock-estimate-pWB6R`,
	"desc": `EarnBlock-desc-HnGzW`
};
module.exports = ___CSS_LOADER_EXPORT___;
